import * as types from './mutation_types'
import ApiService from '@/utils/ApiService'

async function getItems ({ commit }, page = 'client_types?pagination=false&state=1') {
  commit(types.TOGGLE_LOADING)

  const response = await new ApiService(page).getResults()
  commit(types.TOGGLE_LOADING)
  commit(types.SET_ITEMS, response.items)
  commit(types.SET_VIEW, response.view)
}

export default getItems
